import React from 'react';
import _isEmpty from 'lodash/isEmpty';

const MenuSublistSec = ({
  linkClick,
  makeAbFlagUrl,
  data: { values = [], name = '', link = '', hot = {} } = {},
  isLuxeBrandList = false,
  groupLabel=''
}) => {
  if (_isEmpty(values) && _isEmpty(name)) {
    return null;
  }

  return (
    <div className="third-level" id="third">
      {name && link && (
        <div className="title">
          <a
            href={makeAbFlagUrl ? makeAbFlagUrl(link) : link}
            onClick={() => {
              linkClick(link, name);
            }}
          >
            <span><strong>{name}</strong></span>
            {hot ? <span className="hot-ic">hot</span> : null}
          </a>
        </div>
      )}
      {name && !link && (
        <div className="title" >
          <span className="title-tag" role='heading' aria-level={2} id={`heading-${name}`} aria-label={`Brands Starting with ${name}`}><strong>{name}</strong></span>  
          {hot ? <span className="hot-ic">hot</span> : null}
        </div>
      )}
      {groupLabel && !name && (
        <div className="sr-only">
          <span role="heading" aria-level={2} id={`hidden-heading-${groupLabel}`}>{`Continuing Brands Starting with: ${groupLabel}`}</span>
        </div>
      )}
      {values && (
        <div className="items" role="list" aria-labelledby={name ? `heading-${name}` : `heading-${name} hidden-heading-${groupLabel}`}>
          {values.map((data, i) => {
            let { name, link } = data;
            if (link) {
              return (
                <div key={i} role="listitem">
                  <span >
                    <a
                      href={makeAbFlagUrl ? makeAbFlagUrl(link) : link}
                      title={name}
                      onClick={() => {
                        linkClick(link, name);
                      }}
                    >
                      {name}
                    </a>
                  </span>
                </div>
              );
            } else if (isLuxeBrandList && name) {
              return <div key={i} role="listitem"><span>{name}</span></div>;
            } else {
              return null;
            }
          })}
        </div>
      )}
    </div>
  );
};

export default MenuSublistSec;
